export default {
  methods: {
    loadSettings () {
      this.$axios
      .get('settings', {
        headers: { Authorization: 'Bearer ' + localStorage.token }
      })
      .then((response) => response.data)
      .then((data) => {
        this.settingRecord = data
        this.settingRecordMemberStatus = data.showAllMembers
        this.getSettingRecord = data.enableMandatoryCustomerKyc
      })
      .catch(function (error) {
        console.log(error)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/SettingRecords.js